import CryptoJS from 'crypto-js';
import { config } from './utils';
// import heic2any from 'heic2any';
// import { IsNotNullOrEmpty } from './valid';

const decryptString = (value: string) => {
  let decryptedString = '';
  const dataString = value
    .replace(/p1L2u3S/g, '+')
    .replace(/s1L2a3S4h/g, '/')
    .replace(/e1Q2u3A4l/g, '=');
  try {
    decryptedString = CryptoJS.AES.decrypt(
      dataString,
      config.SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
  } catch (error) { }
  return decryptedString;
};

const encryptString = (value: string) => {
  const ciphertext = CryptoJS.AES.encrypt(
    String(value),
    config.SECRET_KEY
  ).toString();
  return ciphertext
    .replace(/\+/g, 'p1L2u3S')
    .replace(/\//g, 's1L2a3S4h')
    .replace(/=/g, 'e1Q2u3A4l');
};

const getAssetURL = (key?: string, _presignedUrl?: string) => {
  // if (
  //   IsNotNullOrEmpty(key) &&
  //   IsNotNullOrEmpty(presignedUrl) &&
  //   config.ENVIRONMENT === 'prod'
  // ) {
  //   
  //   // return presignedUrl;
  // }

  if (!key) {
    return _presignedUrl;
  }

  const url = new URL(`/${key}`, `${config.BACKEND_ATTACHMENT_URL}`).href;
  return url;
  // const url = new URL(`upload-asset/file?key=${key}`, `${config.BASE_URL}`)
  //   .href;

  // if (
  //   fileType == 'image/heic' ||
  //   fileType == 'image/heif' ||
  //   fileType == 'application/octet-stream'
  // ) {
  //   fetch(url, { mode: 'cors' })
  //     .then((res) => res.blob())
  //     .then((blob) => heic2any({ blob }))
  //     .then((conversionResult: any) => {
  //       const imagePreview = document.getElementById(key);

  //       if (imagePreview) {
  //         if (imagePreview instanceof Image) {
  //           imagePreview.src = URL.createObjectURL(conversionResult);
  //         } else {
  //           imagePreview.innerHTML = `<img src="${URL.createObjectURL(
  //             conversionResult
  //           )}">`;
  //         }
  //       }
  //     });
  //   return '';
  // } else {
  //   return url;
  // }
};

export { encryptString, decryptString, getAssetURL };
